import { Container, Grid } from '@mui/material';
import fetcher from 'lib/fetcher';
import { Header } from 'components/Header/Header';
import { Footer } from 'components/Footer/Footer';
import { MetaHead } from 'components/MetaHead/MetaHead';

import { LegalDoc } from 'components/LegalDocs/LegalDoc';
import { FIFTEEN_MINUTES } from 'lib/constants/revalidation';
import { DATENSCHUTZ_LINK_JOBS } from 'consts';
import { LEGAL_HOST } from 'lib/constants/legalDocs';

interface LegalPageProps {
  url: string;
  legalDocument: any;
  pdfUrl: string | null;
  title: string;
}

export default function LegalPage(props: LegalPageProps) {
  const { url, legalDocument, pdfUrl, title } = props;
  const germanDocument = legalDocument?.document['de-DE'];
  const showCookieLink = false; // For the privacy policy, we don't want to show the cookie link in the footer, as the user is already on the page where they can find that information.

  return (
    <>
      <MetaHead
        url={url}
        title={title}
        index={false}
        follow={false}
        datePublished={legalDocument.createdAt}
        dateModified={legalDocument.updatedAt}
      />
      <Header headerStyle="full" />
      <Container maxWidth="lg">
        <Grid container>
          <Grid item xs={12} md={9}>
            <LegalDoc document={germanDocument} pdfLink={pdfUrl} />
          </Grid>
        </Grid>
      </Container>

      <Footer
        footerStyle="minimal"
        datenschutzUrl={DATENSCHUTZ_LINK_JOBS}
        showCookieLink={showCookieLink}
      />
    </>
  );
}

export const getStaticProps = async () => {
  const url = '/jobs/privacy-policy/';
  const legalDocName = 'jobsPrivacyNotice';
  const legalDocTitle =
    'Besondere Datenschutzerklärung für den Bewerbungsprozess';

  const legalDocument = await fetcher(`${LEGAL_HOST}/${legalDocName}.json`);
  const pdfUrl = `${LEGAL_HOST}/${legalDocName}.pdf`;

  return {
    props: {
      url,
      legalDocument,
      pdfUrl,
      title: legalDocTitle,
    },
    revalidate: FIFTEEN_MINUTES,
  };
};
